import React, { useContext } from 'react'
import AppContext from '../../app/context'
import buildStyles from './styles'

export interface ProgressBarProps {
  completed: number
}

const ProgressBar = ({ completed }: ProgressBarProps) => {
  const { state } = useContext(AppContext)
  if (!state.locationDesignConfig) return null

  const styles = buildStyles({
    baseColors: state.locationDesignConfig.baseColors,
  })

  return (
    <div className={styles.meter}>
      <span
        className={styles.span}
        style={{ width: `${completed > 0.5 ? completed : 0.5}%` }}
      />
    </div>
  )
}

export default ProgressBar
